import React from 'react'

function AboutPage() {
    return (
        <div>
            <h1>This is About Page</h1>
        </div>
    )
}

export default AboutPage
